<template>
  <div class="filter">
    <el-form class="elementui-common-form-styles" inline>
      <el-form-item label="新建人">
        <el-select v-model="queryForm.createOpId" filterable clearable @change="sendEvent">
          <el-option v-for="user in PTOM_USERS" :key="user.id" :label="user.name" :value="user.id"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="btn">
      <slot></slot>
    </div>
  </div>
</template>
<script>
import Cookies from 'js-cookie'
import { initPageData, PTOM_USERS } from '@/data/global-opts'
const PAGE_REQUIRED_OPTS = initPageData([PTOM_USERS])
const opId = Cookies.get('ch_op_id')
export default {
  name: 'monitorFilter',
  props: {
    placeholder: {
      type: String
    }
  },
  computed: {
    ...PAGE_REQUIRED_OPTS
  },
  methods: {
    buildParams() {
      return { ...this.queryForm }
    },
    sendEvent() {
      this.$emit('change')
    }
  },
  data() {
    return {
      queryForm: {
        createOpId: opId ? Number(opId) : ''
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.filter {
  display: flex;
  justify-content: space-between;
}
</style>
